export default "__VITE_ASSET__Dh7PTLWB__"